/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface WebImportResponse {
  job_title: string;
  project_title: string;
  description?: string | null;
}
